import { render, staticRenderFns } from "./TenancySubtenant.vue?vue&type=template&id=4ef97064"
import script from "./TenancySubtenant.vue?vue&type=script&lang=js"
export * from "./TenancySubtenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports